"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GridViewColumn;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GridViewColumn = class GridViewColumn {
    static async list(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.GRID_VIEW_COLUMN, [
            viewId
        ]);
        let { list: views } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !views.length) {
            views = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
                condition: {
                    fk_view_id: viewId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.GRID_VIEW_COLUMN, [
                viewId
            ], views);
        }
        views.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return views == null ? void 0 : views.map((v)=>new GridViewColumn(v));
    }
    static async get(context, gridViewColumnId, ncMeta = _Noco.default.ncMeta) {
        let viewColumn = gridViewColumnId && await _NocoCache.default.get(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${gridViewColumnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!viewColumn) {
            viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, gridViewColumnId);
            if (viewColumn) {
                await _NocoCache.default.set(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${gridViewColumnId}`, viewColumn);
            }
        }
        return viewColumn && new GridViewColumn(viewColumn);
    }
    static async insert(context, column, ncMeta = _Noco.default.ncMeta) {
        var _ref, _ref1;
        const insertObj = (0, _extractProps.extractProps)(column, [
            'fk_view_id',
            'fk_column_id',
            'show',
            'base_id',
            'source_id',
            'order',
            'width',
            'group_by',
            'group_by_order',
            'group_by_sort'
        ]);
        insertObj.order = (_ref = column == null ? void 0 : column.order) != null ? _ref : await ncMeta.metaGetNextOrder(_globals.MetaTable.GRID_VIEW_COLUMNS, {
            fk_view_id: column.fk_view_id
        });
        if (!insertObj.source_id) {
            const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
            insertObj.source_id = viewRef.source_id;
        }
        insertObj.width = (_ref1 = column == null ? void 0 : column.width) != null ? _ref1 : _nocodbsdk.VIEW_GRID_DEFAULT_WIDTH + 'px';
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, insertObj);
        if (!ncMeta.upgrader_mode) {
            // TODO: optimize this function & try to avoid if possible
            await _View.default.fixPVColumnForView(context, column.fk_view_id, ncMeta);
        }
        // on new view column, delete any optimised single query cache
        {
            const view = await _View.default.get(context, column.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return this.get(context, id, ncMeta).then(async (viewColumn)=>{
            await _NocoCache.default.appendToList(context, _globals.CacheScope.GRID_VIEW_COLUMN, [
                column.fk_view_id
            ], `${_globals.CacheScope.GRID_VIEW_COLUMN}:${id}`);
            return viewColumn;
        });
    }
    static async update(context, columnId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'order',
            'show',
            'width',
            'group_by',
            'group_by_order',
            'group_by_sort',
            'aggregation'
        ]);
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, updateObj, columnId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${columnId}`, updateObj);
        // on view column update, delete any optimised single query cache
        {
            const gridCol = await this.get(context, columnId, ncMeta);
            const view = await _View.default.get(context, gridCol.fk_view_id, ncMeta);
            await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
        }
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
